unit uDocGenAsigna;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, System.DateUtils;

type
  TFDocGenAsigna = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebEdit1: TEdit;
    WebSpeedButton1: TSpeedButton;
    WebDBGrid1: TDBGrid;
    WebSpeedButton3: TSpeedButton;
    WebHttpRequest1: THttpRequest;
    CEntrenaDoc: TClientConnection;
    TEntrenaDoc: TClientDataSet;
    DsEntrenaDoc: TDataSource;
    CPuestos: TClientConnection;
    TPuestos: TClientDataSet;
    DsPuestos: TDataSource;
    WebPanel3: TPanel;
    WebLabel13: TLabel;
    WebDBGrid2: TDBGrid;
    WebEdit2: TEdit;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebEdit3: TEdit;
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure CEntrenaDocDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure CPuestosBeforeConnect(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebEdit1Enter(Sender: TObject);
    procedure WebDBGrid2DblClick(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

  type
  TProcedureRef = reference to procedure;

var
  FDocGenAsigna: TFDocGenAsigna;

implementation

{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFDocGenAsigna.CEntrenaDocDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
WebDBGrid1.Enabled:=True;
end;

procedure TFDocGenAsigna.CPuestosBeforeConnect(Sender: TObject);
begin
WebSpeedButton6.Visible:=True;
end;

procedure TFDocGenAsigna.WebDBGrid2DblClick(Sender: TObject);
begin
WebEdit1.Text:=TPuestos.FieldByName('Clave').AsString;
WebEdit3.Text:=TPuestos.FieldByName('Puesto').AsString;
WebPanel3.Visible:=False;
end;

procedure TFDocGenAsigna.WebEdit1Enter(Sender: TObject);
begin
WebPanel3.Top:=32;
WebPanel3.Left:=24;
WebPanel3.Visible:=True;
end;

procedure TFDocGenAsigna.WebFormCreate(Sender: TObject);
begin
  // ESTO ES PARA USAR LA NAVEGACION DE LAS FLECHAS se regresa al Form1 o el principal
  asm
    window.onpopstate = function(event) {
    pas.uDocGenAsigna.FDocGenAsigna.Hide();
     };
  end;
  CEntrenaDoc.Command := httpGET;
  CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc?Generico=Generico';
  CEntrenaDoc.Active := True;

  WebDBGrid1.Enabled:=False;

  CPuestos.Command := httpGET;
  CPuestos.URI := 'http://207.244.241.82:9000/Puestos';
  CPuestos.Active := True;
end;

procedure TFDocGenAsigna.WebSpeedButton1Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  TEntrenaDoc.First;
  while not TEntrenaDoc.Eof do
  begin
    try
      Data := TJSONObject.Create;
      Data.AddPair('Puesto', TPuestos.FieldByName('Clave').AsString);
      Data.AddPair('PuestoDes', TPuestos.FieldByName('Puesto').AsString);
      Data.AddPair('Documento', TEntrenaDoc.FieldByName('Codigo').AsString);
      Data.AddPair('DocumentoDes', TEntrenaDoc.FieldByName('Descripcion').AsString);
      Data.AddPair('Revision', TEntrenaDoc.FieldByName('Revision').AsString);
      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaPuestos';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;
      WebHttpRequest1.Execute;
    finally
      Data.Free;
    end;
    TEntrenaDoc.Next;
  end;
ShowMessage('Registros guardados correctamente!!');
end;

procedure TFDocGenAsigna.WebSpeedButton3Click(Sender: TObject);
begin
FDocGenAsigna.Hide;
end;

procedure TFDocGenAsigna.WebSpeedButton5Click(Sender: TObject);
begin
WebPanel3.Visible:=False;
end;

procedure TFDocGenAsigna.WebSpeedButton6Click(Sender: TObject);
begin
if not TPuestos.Locate('Clave', WebEdit2.Text, []) Then
  begin
  ShowMessage('ERROR, NO EXISTE EL PUESTO: '+WebEdit2.Text);
  end;
end;

procedure TFDocGenAsigna.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  DsEntrenaDoc := TDataSource.Create(Self);
  CPuestos := TClientConnection.Create(Self);
  TPuestos := TClientDataSet.Create(Self);
  DsPuestos := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  DsEntrenaDoc.BeforeLoadDFMValues;
  CPuestos.BeforeLoadDFMValues;
  TPuestos.BeforeLoadDFMValues;
  DsPuestos.BeforeLoadDFMValues;
  try
    Name := 'FDocGenAsigna';
    Width := 971;
    Height := 480;
    Caption := 'Asigna documentos gen'#233'ricos';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 16;
    WebPanel1.Width := 624;
    WebPanel1.Height := 121;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.Color := clInfoBk;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 193;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Asignar documentos gen'#233'ricos al puesto';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 48;
    WebLabel2.Width := 37;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Puesto:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebEdit1.SetParentComponent(WebPanel1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 16;
    WebEdit1.Top := 67;
    WebEdit1.Width := 57;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 2;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.ReadOnly := True;
    WebEdit1.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit1, Self, 'OnEnter', 'WebEdit1Enter');
    WebSpeedButton1.SetParentComponent(WebPanel1);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 271;
    WebSpeedButton1.Top := 65;
    WebSpeedButton1.Width := 145;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '    Agregar documento';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uDocGenAsigna.WebPanel1.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebEdit3.SetParentComponent(WebPanel1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 79;
    WebEdit3.Top := 67;
    WebEdit3.Width := 178;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 2;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.ReadOnly := True;
    WebEdit3.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit3, Self, 'OnEnter', 'WebEdit1Enter');
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 8;
    WebDBGrid1.Top := 143;
    WebDBGrid1.Width := 624;
    WebDBGrid1.Height := 329;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Codigo';
      Title := 'Documento';
      Width := 80;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := 'Descripci'#243'n';
      Width := 380;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Revision';
      Title := 'Revision';
      Width := 80;
    end;
    WebDBGrid1.DataSource := DsEntrenaDoc;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 1;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 80;
    WebDBGrid1.ColWidths[2] := 380;
    WebDBGrid1.ColWidths[3] := 80;
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 882;
    WebSpeedButton3.Top := 8;
    WebSpeedButton3.Width := 81;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Salir';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('uDocGenAsigna.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 696;
    WebPanel3.Top := 232;
    WebPanel3.Width := 658;
    WebPanel3.Height := 326;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 8;
    WebPanel3.Color := 16764573;
    WebPanel3.Visible := False;
    WebLabel13.SetParentComponent(WebPanel3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 30;
    WebLabel13.Top := 27;
    WebLabel13.Width := 196;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Busca puesto (C'#243'digo/Clave del puesto):';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebDBGrid2.SetParentComponent(WebPanel3);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 30;
    WebDBGrid2.Top := 79;
    WebDBGrid2.Width := 595;
    WebDBGrid2.Height := 214;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Clave';
      Title := 'Puesto';
      Width := 150;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid2.DataSource := DsPuestos;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 0;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid2, Self, 'OnDblClick', 'WebDBGrid2DblClick');
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 150;
    WebDBGrid2.ColWidths[2] := 350;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 30;
    WebEdit2.Top := 46;
    WebEdit2.Width := 196;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 4;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 247;
    WebSpeedButton6.Top := 49;
    WebSpeedButton6.Width := 100;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := 'Buscar';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uDocGenAsigna.WebPanel3.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.Visible := False;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton5.SetParentComponent(WebPanel3);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 365;
    WebSpeedButton5.Top := 49;
    WebSpeedButton5.Width := 100;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := 'Cancelar';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uDocGenAsigna.WebPanel3.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 656;
    WebHttpRequest1.Top := 48;
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    SetEvent(CEntrenaDoc, Self, 'OnDataReceived', 'CEntrenaDocDataReceived');
    CEntrenaDoc.Left := 656;
    CEntrenaDoc.Top := 112;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 728;
    TEntrenaDoc.Top := 112;
    DsEntrenaDoc.SetParentComponent(Self);
    DsEntrenaDoc.Name := 'DsEntrenaDoc';
    DsEntrenaDoc.DataSet := TEntrenaDoc;
    DsEntrenaDoc.Left := 800;
    DsEntrenaDoc.Top := 112;
    CPuestos.SetParentComponent(Self);
    CPuestos.Name := 'CPuestos';
    CPuestos.Active := False;
    CPuestos.BeforeConnect := CPuestosBeforeConnect;
    CPuestos.Left := 656;
    CPuestos.Top := 168;
    TPuestos.SetParentComponent(Self);
    TPuestos.Name := 'TPuestos';
    TPuestos.Connection := CPuestos;
    TPuestos.Left := 728;
    TPuestos.Top := 168;
    DsPuestos.SetParentComponent(Self);
    DsPuestos.Name := 'DsPuestos';
    DsPuestos.DataSet := TPuestos;
    DsPuestos.Left := 800;
    DsPuestos.Top := 168;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    DsEntrenaDoc.AfterLoadDFMValues;
    CPuestos.AfterLoadDFMValues;
    TPuestos.AfterLoadDFMValues;
    DsPuestos.AfterLoadDFMValues;
  end;
end;

end.
